import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Normalize trailing slash BEFORE React mounts (dev server can't 301)
try {
  const path = window.location.pathname || '';
  if (path.length > 1 && /\/+$/g.test(path)) {
    const clean = path.replace(/\/+$/, '') + window.location.search + window.location.hash;
    window.history.replaceState(null, '', clean);
  }
} catch (_) {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter>
    <App />
    <Toaster
  position="top-center"
  reverseOrder={false}
/>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
